import { useState, useRef, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import Header from './header';
import Nav from './nav';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  width: '100%',
  height: '100vh',
  backdropFilter: 'blur(5px)',
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const mainRef = useRef();

  useEffect(() => {
    const handleScroll = () => {
      if (mainRef.current && mainRef.current.scrollTop > 0) {
        setScrolled(true);
      }
    };

    const scrollElement = mainRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [mainRef]);

  const onCloseNav = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <StyledRoot>
      <Header scrolled={scrolled} onOpenNav={() => setOpen(true)} />

      <Nav openNav={open} onCloseNav={onCloseNav} />

      <Main ref={mainRef}>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
